module.exports = __webpack_public_path__ + "img/xgaltool_old.3736999e.jpg";